import React, { FC } from 'react';
import Paragraph from '../../../ui/Paragraph/Paragraph';
import SharingTruckIcon from '../../../ui/icons/SharingTruck/SharingTruck';
import { useTranslations } from '../../../../hooks/useTranslations';
import { useTheme } from '../../../../hooks/useTheme';
import styles from './GiftTrackingMessage.module.css';
import { clsx } from 'clsx';

interface GiftTrackingMessageProps {
  featureName?: string;
  isLandscape: boolean;
}

const GiftTrackingMessage: FC<GiftTrackingMessageProps> = ({
  featureName,
  isLandscape,
}) => {
  const { giftTrackingRecipientMessage } = useTranslations();
  const { bodytextDefaultNone } = useTheme();

  const containerClasses = clsx(
    isLandscape && styles.containerLandscape,
    !isLandscape && styles.containerPortrait,
  );

  return (
    <div className={containerClasses}>
      <SharingTruckIcon />
      <Paragraph
        disableTheme
        containerCustomStyle={{
          ...bodytextDefaultNone,
          fontWeight: 'bold',
          margin: 0,
          padding: isLandscape ? '0 0 0 1rem' : '1rem 0 0 0',
        }}
      >
        {giftTrackingRecipientMessage}
      </Paragraph>
    </div>
  );
};

export default GiftTrackingMessage;
